<template>
  <div class="py-3">
    <div class="d-flex align-start">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#006341"
            v-bind="attrs"
            v-on="on"
            @click="$router.go(-1)"
            icon
            class="mr-3"
            ><v-icon>mdi-reply</v-icon></v-btn
          >
        </template>
        <span>Back</span>
      </v-tooltip>
      <div>
        <h2>Managing Submissions GPA</h2>
        <!-- <h2 style="font-weight: normal">{{ this.name }}</h2> -->
      </div>
    </div>
    <div v-if="dataSet" class="mt-3">
      <v-row>
        <v-col cols="12" md="4">
          <v-card class="pa-3 rounded-lg" flat>
            <div class="d-flex align-center">
              <v-avatar size="100">
                <img :src="dataSet.scholar.profile_picture" alt="pp" />
              </v-avatar>
              <div class="ml-3">
                <h3>{{ dataSet.scholar.name }}</h3>
                <p class="small_txt grey--text mb-0">
                  {{ dataSet.scholar.no_tf }}
                </p>
                <p class="small_txt grey--text mb-0">
                  {{ dataSet.scholar.email }}
                </p>
              </div>
            </div>
          </v-card>
          <v-card class="pa-3 rounded-lg mt-5" flat>
            <h3 class="text-capitalize text-center">Action</h3>

            <h4>Status</h4>
            <v-select
              :disabled="
                permissions.includes('UPCM') ||
                role == 'VENDOR' ||
                role == 'SUPERADMIN'
                  ? false
                  : true
              "
              class=""
              style="width: 50%"
              dense
              outlined
              hide-details
              :items="optStatusSubmiision"
              item-text="txt"
              item-value="val"
              v-model="dataSet.approval"
              placeholder="Status"
            ></v-select>
            <h5 v-if="dataSet.approval == 'approved'" style="color: red">
              Are you sure you want to change to "approved", you can't change it
              anymore
            </h5>

            <h4 class="text-capitalize mt-2" style="color: black">Comment</h4>
            <v-textarea
              :disabled="
                permissions.includes('UPCM') ||
                role == 'VENDOR' ||
                role == 'SUPERADMIN'
                  ? false
                  : true
              "
              class="my-2"
              auto-grow
              outlined
              hide-details="auto"
              placeholder="Leave a comment..."
              v-model="dataSet.notes"
              rows="3"
            ></v-textarea>
            <v-btn
              v-if="
                permissions.includes('UPCM') ||
                role == 'VENDOR' ||
                role == 'SUPERADMIN'
              "
              color="#016443"
              class="mt-3"
              @click="updateData"
            >
              <h5 v-if="!loading" style="color: white">Save</h5>
              <h5 v-else style="color: white">Loading...</h5>
            </v-btn>
          </v-card>
        </v-col>

        <v-col cols="12" md="8">
          <v-card class="pa-3 rounded-lg" flat>
            <h3 class="text-capitalize">IP Score</h3>
            <v-row>
              <v-col
                cols="12"
                md="6"
                v-for="(value, key) in dataSet.semester"
                :key="key"
              >
                <p class="default_txt">
                  {{ key.replace("semester", "Semester ") }}
                </p>
                <div class="disable_txt">
                  <p class="black--text ma-0">
                    {{ value ? value : "0.00" }}
                  </p>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="disable_txt">
                  <v-icon class="mr-2">mdi-paperclip</v-icon>
                  <a
                    :href="dataSet.attachment"
                    target="_blank"
                    rel="noopener noreferrer"
                    ><b>View Attachment</b></a
                  >
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "listScholarSubmission",
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  components: {},
  data() {
    return {
      loading: false,
      dataSet: null,
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
      optStatusSubmiision: [
        { txt: "Process", val: "process" },
        { txt: "Approved", val: "approved" },
        { txt: "Declined", val: "declined" },
        { txt: "Revision", val: "revision" },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/draft/get?include=scholar&filter[id]=${this.$route.params.idScholar}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          if (data.data && data.data.length) {
            this.dataSet = data.data[0];
            let obj = {};
            for (let key in this.dataSet) {
              if (key.includes("semester")) {
                obj[key] = this.dataSet[key];
              }
            }
            this.dataSet["semester"] = obj;
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateData() {
      this.loading = true;
      let body = {
        scholar_id: this.dataSet.scholar_id,
        scholar_score_draft_id: this.dataSet.id,
        approval: this.dataSet.approval,
        notes: this.dataSet.notes,
      };

      let data = {
        path: `scholar/draft/status`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
        })
        .catch((e) => {
          this.loading = false;
          var key = Object.keys(e.data.errors);
          var values = Object.values(e.data.errors);
          if (key.length == 0) {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          for (let i = 0; i < key.length; i++) {
            for (let j = 0; j < values[i].length; j++) {
              this.$toast.error(values[i][j]);
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.disable_txt {
  padding: 10px;
  border-radius: 5px;
  background: #f6f6f6;
}
</style>
